const ElevShared = require("../../../../shared/ElevShared");
const {
	AJAX_TIMEOUT,
	runAjax,
	toggleClass,
	onClickOrEnter,
	isValidEmail,
	hasPermRole,
} = require("./ElevHelpers");

//
// JS for Contact Us
//

function setupContactUsPage(el) {
	const contactCopy = ElevShared.copyForContactUs();
	const reasonSelectEl = el.querySelector(`select[name="reason-select"]`);
	const roleSelectEl = el.querySelector(`select[name="role-select"]`);
	const reasonEl = el.querySelector(".ba11-p-contact-reasons");
	const roleEl = el.querySelector(".ba11-p-contact-roles");
	const nameEl = el.querySelector(`input[name="Name"]`);
	const emailEl = el.querySelector(`input[name="Email"]`);
	const confirmEmailEl = el.querySelector(`input[name="Confirm Email"]`);
	const subjectEl = el.querySelector(`input[name="Subject"]`);
	const messageEl = el.querySelector(`textarea`);
	const checkboxEl = el.querySelector("#ba11-p-contact-checkbox");
	const errorEl = el.querySelector(".ba11-p-contact-error");
	const submitButtonEl = el.querySelector(".ba11-p-contact-submit");

	const fields = [
		reasonEl,
		roleEl,
		nameEl,
		emailEl,
		confirmEmailEl,
		subjectEl,
		messageEl,
	];

	const isNarrow = () => {
		const windowWidth = window && window.innerWidth;
		return windowWidth && windowWidth <= 700;
	};

	const getReasonValue = () => {
		if (isNarrow()) {
			return reasonSelectEl.value;
		} else {
			const checkedReason = el.querySelector(
				`input[name="reason-radio"]:checked`
			);
			return checkedReason && checkedReason.value;
		}
	};

	const getRoleValue = () => {
		if (isNarrow()) {
			return roleSelectEl.value;
		} else {
			const checkedrole = el.querySelector(`input[name="role-radio"]:checked`);
			return checkedrole && checkedrole.value;
		}
	};

	// Keep narrow and wide version in sync (checking for width to avoid infinite loop)
	const syncInputs = (radioInputs, selectEl, getValue) => {
		selectEl.addEventListener("change", () => {
			if (isNarrow()) {
				for (let i = 0; i < radioInputs.length; i++) {
					if (radioInputs[i].value === selectEl.value) {
						radioInputs[i].checked = true;
						break;
					}
				}
			}
		});
		radioInputs.forEach(radioInput => {
			radioInput.addEventListener("change", () => {
				if (!isNarrow()) selectEl.value = getValue();
			});
		});
	};
	const reasonRadioInputs = Array.from(
		el.querySelectorAll(`input[name="reason-radio"]`)
	);
	const roleRadioInputs = Array.from(
		el.querySelectorAll(`input[name="role-radio"]`)
	);
	syncInputs(reasonRadioInputs, reasonSelectEl, getReasonValue);
	syncInputs(roleRadioInputs, roleSelectEl, getRoleValue);

	// Update contact info when role or reason changes
	const updateContactInfo = () => {
		const role = getRoleValue();
		const reason = getReasonValue();
		// Show IPL if role is Educator OR reason is "schools"
		setContactInfoForRole(role === "Educator" || reason === "schools");
	};
	roleSelectEl.addEventListener("change", updateContactInfo);
	roleRadioInputs.forEach(radioInput => {
		radioInput.addEventListener("change", updateContactInfo);
	});
	reasonSelectEl.addEventListener("change", updateContactInfo);
	reasonRadioInputs.forEach(radioInput => {
		radioInput.addEventListener("change", updateContactInfo);
	});

	let hasSubmitted = false;

	const validate = () => {
		if (!hasSubmitted) return;
		let errorType;
		const errorFields = [];

		if (!getReasonValue()) {
			errorType = "noReasonSelected";
			errorFields.push(reasonEl);
		}
		if (!getRoleValue()) {
			errorType = "noRoleSelected";
			errorFields.push(roleEl);
		}
		if (!messageEl.value || messageEl.value.length < 15) {
			errorType = "messageTooShort";
			errorFields.push(messageEl);
		}
		if (!nameEl.value) {
			errorType = "requiredFieldEmpty";
			errorFields.push(nameEl);
		}
		if (!emailEl.value) {
			errorType = "requiredFieldEmpty";
			errorFields.push(emailEl);
		} else if (!isValidEmail(emailEl.value)) {
			errorType = "invalidEmail";
			errorFields.push(emailEl);
		}
		if (!confirmEmailEl.value) {
			errorType = "requiredFieldEmpty";
			errorFields.push(confirmEmailEl);
		} else if (!isValidEmail(confirmEmailEl.value)) {
			errorType = "invalidEmail";
			errorFields.push(confirmEmailEl);
		} else if (emailEl.value && emailEl.value !== confirmEmailEl.value) {
			errorType = "emailMismatch";
			if (!errorFields.includes(emailEl)) errorFields.push(emailEl);
			errorFields.push(confirmEmailEl);
		}
		if (!subjectEl.value) {
			errorType = "requiredFieldEmpty";
			errorFields.push(subjectEl);
		}

		if (errorType) {
			errorEl.innerText = contactCopy.errors[errorType];
			toggleClass(errorEl, "ba11--invisible", false);
		} else {
			toggleClass(errorEl, "ba11--invisible", true);
		}
		for (let i = 0; i < fields.length; i++) {
			toggleClass(
				fields[i],
				"ba11-p-contact-error-field",
				errorFields.includes(fields[i])
			);
		}

		return !errorType;
	};

	let editableFields = [
		reasonSelectEl,
		roleSelectEl,
		nameEl,
		emailEl,
		confirmEmailEl,
		subjectEl,
		messageEl,
	];
	editableFields = editableFields.concat(reasonRadioInputs);
	editableFields = editableFields.concat(roleRadioInputs);
	editableFields.forEach(field => field.addEventListener("change", validate));

	let numAttempts = 0;

	const onSubmit = () => {
		hasSubmitted = true;
		const valid = validate();
		const statusSection = el.querySelector(".ba11-p-contact-status-container");
		const sections = {
			contactForm: el.querySelector(".ba11-p-contact-form"),
			sending: el.querySelector(".ba11-p-contact-sending"),
			complete: el.querySelector(".ba11-p-contact-complete"),
			failedRetry: el.querySelector(".ba11-p-contact-failed-retry"),
			failedNoRetry: el.querySelector(".ba11-p-contact-failed-no-retry"),
		};

		const showContactSection = function(section) {
			const keys = Object.keys(sections);
			for (let i = 0; i < keys.length; i++) {
				toggleClass(sections[keys[i]], "ba11--hidden", section !== keys[i]);
			}
			toggleClass(statusSection, "ba11--hidden", section === "contactForm");
		};

		if (valid) {
			numAttempts++;
			showContactSection("sending");
			const reason = getReasonValue();
			const role = getRoleValue();
			runAjax(
				{
					endpoint: "/api/store/contact",
					timeout: AJAX_TIMEOUT,
					payload: {
						name: nameEl.value,
						email: emailEl.value,
						subject: subjectEl.value,
						subscribe: checkboxEl.checked,
						message: messageEl.value,
						reason: contactCopy.reasons[reason],
						role,
						isForSchool: role === "Educator" || reason === "schools",
						isForProspectiveCustomer: [
							"recommendations",
							"orderingInfo",
							"prospectiveCustomerOther",
						].includes(reason),
						isForExistingCustomer: [
							"account",
							"ordersAndBilling",
							"customerOther",
						].includes(reason),
						isTechSupport: reason === "techSupport",
						previousPage: null,
						diagnostics: getDiagnosticsInfo(),
					},
				},
				(err, res) => {
					if (!err && res && res.success) {
						showContactSection("complete");
					} else {
						if (numAttempts > 2) {
							showContactSection("failedRetry");
						} else {
							showContactSection("failedNoRetry");
						}
					}
				}
			);
		}
	};

	onClickOrEnter(submitButtonEl, onSubmit);
	const retryButtonEl = el.querySelector(".ba11-p-contact-status-retry-button");
	onClickOrEnter(retryButtonEl, onSubmit);
}

// Toggle contact info between AoPS (default) and IPL (for educators/school staff)
function setContactInfoForRole(isEducator) {
	const companyEls = document.querySelectorAll(".ba11-p-contact-company");
	const emailInfoEl = document.querySelector(".ba11-p-contact-email");
	const emailInfoNarrowEl = document.querySelector(
		".ba11-p-contact-email-narrow"
	);
	const phoneInfoEl = document.querySelector(".ba11-p-contact-phone");
	const faxEls = document.querySelectorAll(".ba11-p-contact-fax");

	if (isEducator) {
		// Show IPL info for educators/school staff
		companyEls.forEach(el => {
			el.innerText = "c/o Inflection Point Learning";
		});
		if (emailInfoEl) {
			emailInfoEl.innerText = "schools@inflectionpointlearning.com";
		}
		if (emailInfoNarrowEl) {
			emailInfoNarrowEl.innerText = "schools@inflectionpointlearning.com";
		}
		if (phoneInfoEl) {
			phoneInfoEl.innerText = "Phone: (858) 275-2900";
		}
		faxEls.forEach(el => {
			el.style.display = "none";
		});
	} else {
		// Show default AoPS info
		companyEls.forEach(el => {
			el.innerText = "c/o Art of Problem Solving";
		});
		if (emailInfoEl) {
			emailInfoEl.innerText = "info@beastacademy.com";
		}
		if (emailInfoNarrowEl) {
			emailInfoNarrowEl.innerText = "info@beastacademy.com";
		}
		if (phoneInfoEl) {
			phoneInfoEl.innerText = "";
		}
		faxEls.forEach(el => {
			el.style.display = "";
		});
	}
}

function setupContactPagePostAuth(user) {
	const isParent = hasPermRole(user, "parent");
	const isTeacher = hasPermRole(user, "teacher");

	if (isTeacher) {
		setContactInfoForRole(true);
	}

	const roleSelectEl = document.querySelector("#ba11-p-contact-role-select");
	const emailEl = document.querySelector(`input[name="Email"]`);
	const confirmEmailEl = document.querySelector(`input[name="Confirm Email"]`);

	if (user && user.email && emailEl && confirmEmailEl) {
		emailEl.value = user.email;
		confirmEmailEl.value = user.email;
	}

	if (isParent && roleSelectEl) {
		roleSelectEl.value = "Parent";
		const parentRadioEl = document.querySelector("#role-radio-parent");
		parentRadioEl.checked = true;
	} else if (isTeacher && roleSelectEl) {
		roleSelectEl.value = "Educator";
		const educatorRadioEl = document.querySelector("#role-radio-educator");
		educatorRadioEl.checked = true;
		const nameField = document.querySelector("#ba11-p-contact-name-field");
		nameField.value = user.firstName + " " + user.lastName;
	}

	if ((isParent || isTeacher) && roleSelectEl) {
		const reasonSelectSubtitle = document.querySelectorAll(
			`option[name="reason-select-subtitle"]`
		);
		const reasonSelectProspective = document.querySelectorAll(
			`option[name="reason-select-prospective"]`
		);
		for (let i = 0; i < reasonSelectSubtitle.length; i++) {
			reasonSelectSubtitle[i].style.display = "none";
		}
		for (let j = 0; j < reasonSelectProspective.length; j++) {
			reasonSelectProspective[j].style.display = "none";
		}
		const propsectiveReasonOptions = document.querySelector(
			"#ba11-p-contact-radio-reason-prospective"
		);
		propsectiveReasonOptions.style.display = "none";
	}
}

//
// Diagnostics Info
//

function getDiagnosticsInfo() {
	// TODO: generate diagnostics info we send to the API
	return null;
}

module.exports = {
	setupContactUsPage,
	setupContactPagePostAuth,
};
